// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-item {
  --ion-item-background: #ffffff;
  --padding-start: 10px;
  --padding-end: 10px;
  --inner-padding-end: 0px;
  background: #f9f9fb;
  --background: #f9f9fb;
  border-radius: 8px;
  box-shadow: 0px 0px 15px rgba(0, 0, 0, 0.2);
  transition: all 0.15s;
  --background-focused: unset !important;
  --border-style: solid;
  --border-width: 1px;
  --border-radius: 8px;
  --border-color: transparent;
}

ion-item.item-interactive-disabled {
  --background: transparent;
  background: transparent;
  border: 1px solid #a7a7a7;
  box-shadow: unset;
}

ion-item.item-interactive-disabled > ion-input {
  --background: transparent;
  background: transparent;
}

ion-item.item-interactive-disabled > ion-input > input {
  opacity: 1 !important;
}

ion-input {
  transition: all 0.15s;
  background: #f9f9fb;
  text-indent: 8px;
  color: #576d7c;
  font-size: 20px;
  font-weight: 600;
}

input {
  opacity: 0.89 !important;
  position: relative;
}

ion-label {
  margin: 0;
  margin-bottom: 4px !important;
  text-align: center;
  align-self: center !important;
}

.input-header {
  color: #65b2e5;
  font-size: 20px;
  font-weight: 600;
}

ion-grid,
ion-col {
  padding-left: 0;
  padding-right: 0;
}

.show-hide-pwd {
  width: 24px;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/input/input.component.scss"],"names":[],"mappings":"AAAA;EACE,8BAAA;EACA,qBAAA;EACA,mBAAA;EACA,wBAAA;EACA,mBAAA;EACA,qBAAA;EACA,kBAAA;EACA,2CAAA;EACA,qBAAA;EACA,sCAAA;EACA,qBAAA;EACA,mBAAA;EACA,oBAAA;EACA,2BAAA;AACF;;AAEA;EACE,yBAAA;EACA,uBAAA;EACA,yBAAA;EACA,iBAAA;AACF;;AAEA;EACE,yBAAA;EACA,uBAAA;AACF;;AAEA;EACE,qBAAA;AACF;;AAEA;EACE,qBAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AACF;;AAEA;EACE,wBAAA;EACA,kBAAA;AACF;;AAEA;EACE,SAAA;EACA,6BAAA;EACA,kBAAA;EACA,6BAAA;AACF;;AAEA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;AACF;;AAEA;;EAEE,eAAA;EACA,gBAAA;AACF;;AAEA;EACE,WAAA;AACF","sourcesContent":["ion-item {\r\n  --ion-item-background: #ffffff;\r\n  --padding-start: 10px;\r\n  --padding-end: 10px;\r\n  --inner-padding-end: 0px;\r\n  background: #f9f9fb;\r\n  --background: #f9f9fb;\r\n  border-radius: 8px;\r\n  box-shadow: 0px 0px 15px #00000033;\r\n  transition: all 0.15s;\r\n  --background-focused: unset !important;\r\n  --border-style: solid;\r\n  --border-width: 1px;\r\n  --border-radius: 8px;\r\n  --border-color: transparent;\r\n}\r\n\r\nion-item.item-interactive-disabled {\r\n  --background: transparent;\r\n  background: transparent;\r\n  border: 1px solid #a7a7a7;\r\n  box-shadow: unset;\r\n}\r\n\r\nion-item.item-interactive-disabled > ion-input {\r\n  --background: transparent;\r\n  background: transparent;\r\n}\r\n\r\nion-item.item-interactive-disabled > ion-input > input {\r\n  opacity: 1 !important;\r\n}\r\n\r\nion-input {\r\n  transition: all 0.15s;\r\n  background: #f9f9fb;\r\n  text-indent: 8px;\r\n  color: #576d7c;\r\n  font-size: 20px;\r\n  font-weight: 600;\r\n}\r\n\r\ninput {\r\n  opacity: 0.89 !important;\r\n  position: relative;\r\n}\r\n\r\nion-label {\r\n  margin: 0;\r\n  margin-bottom: 4px !important;\r\n  text-align: center;\r\n  align-self: center !important;\r\n}\r\n\r\n.input-header {\r\n  color: #65b2e5;\r\n  font-size: 20px;\r\n  font-weight: 600;\r\n}\r\n\r\nion-grid,\r\nion-col {\r\n  padding-left: 0;\r\n  padding-right: 0;\r\n}\r\n\r\n.show-hide-pwd {\r\n  width: 24px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
